import { Box } from '@factorialco/deprecated-design-system'
import {
  CoCreationForm,
  CoCreationFormElement,
  QuestionType,
} from '@factorialco/f0-react/dist/experimental'

import {
  FromFormToQuestionnaire,
  FromQuestionnaireToForm,
} from 'modules/forms/components/newFormEditor/helpers'

import { QuestionnaireType } from './types'

interface FormEditorProps {
  state: QuestionnaireType
  setState: (state: QuestionnaireType) => void
  allowedQuestionTypes?: QuestionType[]
  enabled?: boolean
}

export const FormEditor = ({ state, setState, allowedQuestionTypes, enabled }: FormEditorProps) => {
  const elements = FromQuestionnaireToForm(state.elements)

  const handleChange = (updatedElements: CoCreationFormElement[]) => {
    setState?.({ ...state, elements: FromFormToQuestionnaire(updatedElements) })
  }

  return (
    <Box gap="s16" width="s600" alignSelf="center" height="full">
      <CoCreationForm
        isEditMode={enabled}
        elements={elements}
        onChange={handleChange}
        allowedQuestionTypes={allowedQuestionTypes}
      />
    </Box>
  )
}
